module.exports = __webpack_public_path__ + "static/media/11_l_kartini_6.51_68.15.cb082b5b.png";